const Edit = ({ color, type }) => {
  const regular = (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.3327 5.95709C19.723 5.56654 20.356 5.56628 20.7467 5.9565L24.0422 9.2483C24.433 9.63869 24.4333 10.272 24.0428 10.6627L11.3654 23.3471C11.2261 23.4865 11.0487 23.5816 10.8556 23.6205L5.25 24.75L6.38149 19.1512C6.42045 18.9584 6.51536 18.7814 6.65438 18.6423L19.3327 5.95709Z"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Edit;
